import { Grid, GridItem, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import Sidebar from "./Sidebar";

const Layout: React.FC = (props) => {
  return (
    <Grid h="100vh" templateColumns="300px 1fr" overflowY="hidden">
      <GridItem bg={useColorModeValue("gray.800", "gray.800")} boxShadow="md" zIndex="docked">
        <Sidebar></Sidebar>       
        </GridItem>
      <GridItem bg={useColorModeValue("gray.50", "gray.900")}>{props.children}</GridItem>
    </Grid>
  );
};

export default Layout;
